export default {
  empty: 'Dla tej pracy nie zarejestrowano zużycia.',
};
